import styled from "@emotion/styled";
import colors from "../../styles/colors";
export const TextPillContainer = styled.div `
  padding: 0.563rem 1rem 0.5rem 1rem;
  border-radius: 9999px;
  width: fit-content;
  letter-spacing: 0.03125rem;
  ${(props) => `background-color:${colors[props.bgColor]}`};
`;
export const TextPillSpan = styled.span `
  font-family: "Inter";
  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: 600;
  display: block;
  letter-spacing: 0.03125rem;
  ${(props) => `color:${colors[props.color]}`};
`;
//# sourceMappingURL=TextPill.styled.js.map